import api from './api';

export const reportsV2Service = {
  // 보고서 생성
  generateReport: async (reportData) => {
    try {
      const response = await api.post('/reports-v2/generate', reportData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error?.message || '보고서 생성에 실패했습니다.');
    }
  },

  // 보고서 목록 조회
  getReports: async () => {
    try {
      const response = await api.get('/reports-v2');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error?.message || '보고서 목록 조회에 실패했습니다.');
    }
  },

  // 특정 보고서 조회
  getReport: async (reportId) => {
    try {
      const response = await api.get(`/reports-v2/${reportId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error?.message || '보고서 조회에 실패했습니다.');
    }
  },

  // AI 분석 결과 업데이트
  updateAIAnalysis: async (reportId, analysis) => {
    try {
      const response = await api.put(`/reports-v2/${reportId}/ai-analysis`, {
        analysis
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error?.message || 'AI 분석 업데이트에 실패했습니다.');
    }
  },

  // 보고서 결과 조회
  getReportResults: async (reportId) => {
    try {
      const response = await api.get(`/reports-v2/${reportId}/results`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error?.message || '보고서 결과 조회에 실패했습니다.');
    }
  },

  // PDF 생성 요청
  generatePDF: async (reportId) => {
    try {
      const response = await api.post(`/reports-v2/${reportId}/pdf`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error?.message || 'PDF 생성 요청에 실패했습니다.');
    }
  },

  // PDF 다운로드 URL 조회
  getPDFDownloadUrl: async (reportId) => {
    try {
      const response = await api.get(`/reports-v2/${reportId}/pdf/download`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error?.message || 'PDF 다운로드 URL 조회에 실패했습니다.');
    }
  },

  regenerateAI: async (reportId) => {
    try {
      const response = await api.post(`/reports-v2/${reportId}/ai-analysis/regenerate`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error?.message || 'AI 재요청에 실패했습니다.');
    }
  },

  appendEditHistory: async (reportId, entry) => {
    try {
      const response = await api.post(`/reports-v2/${reportId}/history`, { entry });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error?.message || '이력 추가에 실패했습니다.');
    }
  },

  rollbackHistory: async (reportId, historyIndex) => {
    try {
      const response = await api.post(`/reports-v2/${reportId}/history/${historyIndex}/rollback`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error?.message || '롤백에 실패했습니다.');
    }
  },

  // 보고서 메타데이터 업데이트
  updateMetadata: async (reportId, metadata) => {
    try {
      const response = await api.put(`/reports-v2/${reportId}/metadata`, { metadata });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error?.message || '메타데이터 업데이트에 실패했습니다.');
    }
  },

  // 보고서 결과 업데이트
  updateResult: async (reportId, resultType, data) => {
    try {
      const response = await api.put(`/reports-v2/${reportId}/results/${resultType}`, { data });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error?.message || '결과 업데이트에 실패했습니다.');
    }
  },

  // 보고서 결과 삭제
  deleteResult: async (reportId, resultType, { skipHistory = false } = {}) => {
    try {
      const url = skipHistory
        ? `/reports-v2/${reportId}/results/${resultType}?skipHistory=true`
        : `/reports-v2/${reportId}/results/${resultType}`;
      const response = await api.delete(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error?.message || '결과 삭제에 실패했습니다.');
    }
  },

  // 보고서 삭제
  deleteReport: async (reportId) => {
    try {
      const response = await api.delete(`/reports-v2/${reportId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error?.message || '보고서 삭제에 실패했습니다.');
    }
  }
};

export default reportsV2Service;